import Wrapper from "components/wrapper/wrapper"
export default Wrapper